// extracted by mini-css-extract-plugin
export default {"volunteer":"Volunteer_volunteer__SR798"};